module.exports = __webpack_public_path__ + "img/content-1.e58bb3c5.png";